export const homeRoutes  = [
  '/',
  '/about',
  '/register',
  '/passwordreset'
  ]
  
  export default {
    routes: homeRoutes,
  }